import posthog from 'posthog-js'
import { config, isPostHogEnabled } from './config'

// Initialize PostHog only in production
export const initPostHog = () => {
  try {
    // Only initialize PostHog in production builds and if not already initialized
    if (isPostHogEnabled() && !posthog.__loaded) {
      posthog.init(config.posthog.apiKey!, {
        api_host: config.posthog.apiHost,
        loaded: (posthog) => {
          // Debug mode only in production if needed
          if (config.env.isDev) posthog.debug()
        },
        capture_pageview: false, // We'll handle this manually
        capture_pageleave: true,
        session_recording: {
          maskAllInputs: false,
          maskInputOptions: {},
          maskTextSelector: null,
          recordCrossOriginIframes: false,
        },
        autocapture: true,
        disable_session_recording: false,
        enable_recording_console_log: true,
      })
    } else if (isPostHogEnabled() && posthog.__loaded) {
      console.log('PostHog already initialized, skipping...')
    } else {
      console.log('PostHog disabled in development mode')
    }
  } catch (error) {
    console.error('Failed to initialize PostHog:', error)
  }
}

// Track page views - only in production
export const trackPageView = (path: string) => {
  if (isPostHogEnabled() && posthog && typeof posthog.isFeatureEnabled === 'function' && posthog.isFeatureEnabled('pageview-tracking')) {
    posthog.capture('$pageview', {
      $current_url: window.location.href,
      path: path
    })
  }
}

// Track custom events - only in production
export const trackEvent = (eventName: string, properties?: Record<string, unknown>) => {
  if (isPostHogEnabled()) {
    posthog.capture(eventName, properties)
  } else {
    console.log('PostHog Event (dev):', eventName, properties)
  }
}

// Identify user - only in production
export const identifyUser = (userId: string, properties?: Record<string, unknown>) => {
  if (isPostHogEnabled()) {
    posthog.identify(userId, properties)
  } else {
    console.log('PostHog Identify (dev):', userId, properties)
  }
}

// Reset user (for logout) - only in production
export const resetUser = () => {
  if (isPostHogEnabled()) {
    posthog.reset()
  } else {
    console.log('PostHog Reset (dev)')
  }
}

export default posthog 